const validationConstraintsSpec: { [key: string]: string } = {
  minlength: 'minLength',
  maxlength: 'maxLength',
  pattern: 'pattern',
  required: 'required',
  min: 'min',
  max: 'max',
  readonly: 'disabled',
};

export default validationConstraintsSpec;
